function showMessage(form, message) {
  const target = form.querySelector('[data-rtr-message]');
  if (!target) return;
  target.textContent = message;
  target.hidden = !message;
}

function showCodeError(form, message) {
  const input = form.elements.code;
  if (!input) {
    showMessage(form, message);
    return;
  }

  input.setAttribute('aria-invalid', 'true');
  if (typeof window.formValidation === 'function') {
    window.formValidation({ form_id: form.id, names: { code: [message] } });
    const error = input.closest('.meta-input')?.querySelector('.error-text');
    error?.remove();
  }

  showMessage(form, message);
  const errorMessage = form.querySelector('[data-rtr-message]');
  if (errorMessage?.id) input.setAttribute('aria-describedby', errorMessage.id);
  input.focus();
}

function responseMessage(response, data) {
  if (response.status === 410 || response.status === 404) {
    return 'This invitation is invalid, expired, or has already been completed.';
  }
  if (response.status === 419) {
    return 'Your session has expired. Please reload this page and try again.';
  }
  if (response.status === 429) {
    return 'Too many attempts. Please wait before trying again.';
  }
  return data?.errors?.code?.[0] || 'Something went wrong. Please try again.';
}

export function initRtrInvitations(root = document) {
  if (typeof window.fetch !== 'function') return;

  root.querySelectorAll('[data-rtr-invitation] form').forEach((form) => {
    if (form.dataset.rtrInitialized === 'true') return;
    form.dataset.rtrInitialized = 'true';
    form.noValidate = true;

    const group = form.closest('[data-rtr-invitation]') || form;
    const input = form.elements.code;
    input?.addEventListener('input', () => {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
      input.classList.remove('error', '!border-red-500');
      showMessage(form, '');
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (group.dataset.rtrBusy === 'true') return;
      showMessage(form, '');

      if (input && !/^[0-9]{6}$/.test(input.value)) {
        showCodeError(form, input.value ? 'Enter the 6-digit verification code.' : 'Please enter your verification code.');
        return;
      }

      const buttons = [...group.querySelectorAll('button[type="submit"]')];
      group.dataset.rtrBusy = 'true';
      group.setAttribute('aria-busy', 'true');
      buttons.forEach((button) => { button.disabled = true; });

      try {
        const response = await window.fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          cache: 'no-store',
        });
        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          const message = responseMessage(response, data);
          if (input && response.status === 422 && data.errors?.code) showCodeError(form, message);
          else showMessage(form, message);
          return;
        }

        if (input && data.redirect) {
          const destination = new URL(data.redirect, window.location.href);
          if (destination.origin !== window.location.origin) throw new Error('Invalid redirect');
          window.location.assign(destination.href);
        } else if (!input && data.status) {
          window.location.reload();
        } else {
          showMessage(form, 'Something went wrong. Please try again.');
        }
      } catch {
        showMessage(form, 'We could not complete your request. Please try again.');
      } finally {
        delete group.dataset.rtrBusy;
        group.removeAttribute('aria-busy');
        buttons.forEach((button) => { button.disabled = false; });
      }
    });
  });
}

if (typeof document !== 'undefined') initRtrInvitations();
